import Vue from 'vue';
import { ModelItem } from '@/models/Model';
import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';


export class ModelsService extends Vue {
    private baseAPI = process.env.VUE_APP_API_URL;
    private commonAPI = process.env.VUE_APP_API_COMMON_URL;
    private authService = new AuthenService();
    private commonService = new CommonService();
    constructor() {
        super();
    }

    get headers() {
        return {
            'Content-Type': 'application/json',
            'auth': localStorage.getItem('token'),
        };
    }

    public async getKyotens() {
        return this.commonService.getKyotens();
    }

    public async getModels(kyoten: string, id?: number) {
        const { result, error } = await this.commonService.get(id
            ? `${this.baseAPI}/proposals/${id}`
            : `${this.baseAPI}/proposals?q=kyotenCd=${kyoten}`);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getModels');
            return;
        }
    }

    public async editModel(data: ModelItem) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/proposals/`, { ...data });
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'editModel');
            return;
        }
    }

    public async deleteModel(id: number) {
        const { result, error } = await this.commonService.delete(`${this.baseAPI}/proposals/${id}`);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'deleteModel');
            return;
        }
    }

    public async saveModels(data: any[]) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/proposals-order-display`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'saveModels');
            return;
        }
    }


}
